import styled from 'styled-components';

export const Container = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',

  [theme.breakpoint.media.max.sm]: {
    paddingInline: '24rem',
  },
}));

export const ButtonContainer = styled.div({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBlock: '10rem',
});
